module.exports = __webpack_public_path__ + "static/img/fundamentals.94f119f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/fundamentals.png
// module id = oJsZ
// module chunks = 0